import { useEffect } from "react";

export default function FullPageLoader() {
  useEffect(() => {
    async function getLoader() {
      const { grid } = await import("ldrs");
      
      grid.register();
    }
    getLoader();
  }, []);
  return (
    <div className="fixed h-screen w-full flex flex-col gap-2 items-center justify-center inset-0 bg-white">
      <l-grid size="120" speed={1.5} color={"#343a40"} />
      <h1 className="text-2xl font-black font-serif text-body italic">
        Affinity
      </h1>
    </div>
  );
}
